import React from 'react';

class ErrorBoxView extends React.Component {
    constructor(props) {
		super(props);

        this.state = {};
    };
    
    render() {
        return (
            <div className="message_cnt pos_abs full_height full_width">
                <span dangerouslySetInnerHTML={{ __html: this.props.dataHtml }}></span>
            </div>
        )
    };
}

export default ErrorBoxView;